import moment from "moment";

export const isPlainObject = (value) =>
  !!value && typeof value === "object" && !Array.isArray(value);

// Any value -> trimmed string ("" for null/undefined/objects).
export const toSafeString = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return "";
  return String(value).trim();
};

// Value that React can render as text, or null (objects/arrays are not renderable).
export const toDisplayText = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "number" || typeof value === "string") return String(value);
  return null;
};

// Formats a timestamp; returns fallback when missing or invalid.
export const formatDateTime = (value, format, fallback = "-") => {
  if (value === null || value === undefined || value === "") return fallback;
  const date = moment(value);
  return date.isValid() ? date.format(format) : fallback;
};

// A usable event must be an object; missing fields get safe defaults.
export const normalizeEvent = (event) => {
  if (!isPlainObject(event)) return null;
  const receivedAt = Number(event.receivedAt);
  return {
    ...event,
    eventId: toSafeString(event.eventId),
    eventName: toSafeString(event.eventName),
    eventSrc: toSafeString(event.eventSrc || event.eventSource),
    eventPayload: isPlainObject(event.eventPayload) ? event.eventPayload : null,
    receivedAt: Number.isFinite(receivedAt) ? receivedAt : Date.now(),
  };
};

// Keeps only valid events from any input (null, non-array, bad items).
export const normalizeEvents = (events) =>
  Array.isArray(events) ? events.map(normalizeEvent).filter(Boolean) : [];
